module.exports = __webpack_public_path__ + "static/media/formulae-tile.5c0cae64.jpg";